module.exports = __webpack_public_path__ + "img/black-ribbon.469d11e2.svg";